const messages = {
    scanWithBankApp: "ស្កេនដោយប្រើកម្មវិធីធនាគាររបស់អ្នក",
    scanWithCreditCardApp: "ស្កេនដោយប្រើកម្មវិធីកាតឥណទានរបស់អ្នក",
    scanOrOpenApp: "ស្កេន ឬបើកកម្មវិធីដើម្បីបញ្ចប់ការទូទាត់",
    scanForPayment: "ស្កេនដើម្បីទូទាត់",
    scanWithBankApp: 'ស្កេនដោយកម្មវិធីធនាគាររបស់អ្នកដើម្បីទូទាត់',
    changePaymentWarning: "នៅពេលអ្នកផ្លាស់ប្ដូរវិធីទូទាត់ QR Code ពីមុននឹងមិនមានសុពលភាពទៀតទេ។ សូមប្រើវិធីថ្មីតែប៉ុណ្ណោះ។",
    swapShop: "តើអ្នកចង់ប្ដូរទៅ<br>ហាងថ្មីទេ?",
    swapShopDespt: "ទំនិញដែលបានជ្រើសរើសពីហាងមុននឹងត្រូវបានរក្សាទុក ហើយអាចបញ្ជាទិញនៅពេលក្រោយ",
    sorryForInconvenient: 'សូមអភ័យទោសចំពោះការរអាក់រអួល',
    openAt: 'បើកនៅម៉ោង',
    shopIsClosedToday: 'ហាងបិទថ្ងៃនេះ',
    checkOrderedItem: 'ពិនិត្យមើលម្ហូបដែលបានបញ្ជាទិញ',
    tryAgainIn: 'សាកល្បងម្ដងទៀតនៅ',
    lockUserPIN: "អ្នកបានបញ្ចូល PIN ខុសច្រើនជាង 5 ដង",
    lockUserPINDespt: "សាកល្បងម្ដងទៀតក្នុងរយៈពេល 5 នាទី",
    inValidPIN: 'PIN មិនត្រឹមត្រូវ',
    enterPasswordToAccessMenu: "បញ្ចូល PIN ដើម្បីចូលមើលម៉ឺនុយ",
    customersCanGetPasswordFromStaff: "អតិថិជនអាចទទួល PIN ពីបុគ្គលិក",
    tableNotAvailable: "តុមិនអាចប្រើបានទេ",
    contactStaffToOpenTable: "ទាក់ទងបុគ្គលិកដើម្បីបើកតុ",
    outOfRestaurantRange: "នៅក្រៅតំបន់ភោជនីយដ្ឋាន",
    phoneIsMoreThan100MetersAwayFromRestaurant: "ទូរសព្ទរបស់អ្នកនៅឆ្ងាយពីភោជនីយដ្ឋានច្រើនជាង 100 ម៉ែត្រ",
    restaurantIsCurrentlyClosed: "ភោជនីយដ្ឋានបិទបច្ចុប្បន្ន",
    restaurantOpenHours: "ផ្ទះបាយបើកពីម៉ោង",
    packingSize: 'ទំហំកញ្ចប់',
    shippingDelivery: 'ដឹកជញ្ជូន',
    waitForPaymentDelivery: 'រង់ចាំការទូទាត់',
    readyForPcikup: 'រួចរាល់សម្រាប់ទទួល',
    noNotifyNow: "បច្ចុប្បន្នមិនមានការជូនដំណឹងទេ",
    noNotifyNowDespt: "នៅពេលអ្នកចាប់ផ្ដើមប្រើសេវាកម្ម ការជូនដំណឹងនឹងបង្ហាញនៅទីនេះ",
    newAddressDespt: "ដើម្បីងាយស្រួលក្នុងការដឹកជញ្ជូន សូមកំណត់ទីតាំងត្រឹមត្រូវ និងអនុញ្ញាតឱ្យចូលប្រើទីតាំងរបស់អ្នក",
    deleteAddressSuccess: 'លុបអាសយដ្ឋានជោគជ័យ',
    createProfileSuccess: "បង្កើតប្រវត្តិរូបជោគជ័យ",
    ex: 'ឧទា.',
    receiverName: 'ឈ្មោះអ្នកទទួល',
    editAddress: 'កែសម្រួលអាសយដ្ឋាន',
    nameInputInvalid: 'ឈ្មោះមិនត្រឹមត្រូវ',
    openInGoogleMap: 'បើកក្នុង Google Map',
    pleaseSelectPaymentMethod: 'សូមជ្រើសរើសវិធីទូទាត់',
    noDeliveryAddress: 'មិនមានអាសយដ្ឋានដឹកជញ្ជូនទេ',
    noDeliveryAddressDespt: 'សូមបន្ថែមព័ត៌មានអាសយដ្ឋានដឹកជញ្ជូន',
    deliveryType: 'ដឹកជញ្ជូន',
    pickupType: 'ទទួលដោយខ្លួនឯង',
    shopIsClose: 'ហាងបិទ',
    openingHoursDespt: 'ម៉ោងបើកដំណើរការ',
    contactShop: 'ទាក់ទងហាង',
    pickupAtShop: 'ទទួលដោយខ្លួនឯង',
    thanksForOrderingDespt: 'សូមអរគុណសម្រាប់ការគាំទ្រ។<br>យើងរំពឹងថានឹងបានជួបអ្នកម្ដងទៀត!',
    deliveredSuccess: 'ដឹកជញ្ជូនជោគជ័យ',
    expireIn: 'ផុតកំណត់ក្នុង',
    waitForPayment: 'រង់ចាំការទូទាត់',
    waitForPaymentDespt: "សូមរង់ចាំការបញ្ជាក់ការទូទាត់ពីប្រព័ន្ធ។<br>ប្រសិនបើអ្នកមិនទាន់បានទូទាត់ សូមបញ្ចប់ការទូទាត់ក្នុងរយៈពេលកំណត់ ដើម្បីជៀសវាងការលុបបោះការបញ្ជាទិញ។",
    newOrderIn: 'ថ្មី',
    inputRequestDetails: 'បញ្ជាក់ព័ត៌មានលម្អិតសំណើ',
    notification: 'ការជូនដំណឹង',
    noticeIfOrderReady: 'យើងនឹងជូនដំណឹងអ្នកនៅពេលការបញ្ជាទិញរួចរាល់សម្រាប់ទទួល',
    orderIsReady: 'ការបញ្ជាទិញរបស់អ្នករួចរាល់សម្រាប់ទទួល',
    thanksForOrdering: 'សូមអរគុណសម្រាប់ការប្រើប្រាស់សេវាកម្មរបស់យើង',
    toPay: 'ទូទាត់',
    letOrder: 'ទៅទំព័រម៉ឺនុយ ហើយចាប់ផ្ដើមបញ្ជាទិញឥឡូវ',
    noTransaction: 'គ្មានប្រតិបត្តិការ',
    menulists: 'បញ្ជីម៉ឺនុយ',
    editPersonalDetails: 'កែសម្រួលព័ត៌មាន',
    trackOrder: 'តាមដានការបញ្ជាទិញ',
    myAccount: 'គណនីរបស់ខ្ញុំ',
    cart: 'កន្រ្ដក',
    helpCenter: 'មជ្ឈមណ្ឌលជំនួយ',
    allPurchaseHistory: 'ប្រវត្តិការទិញ',
    purchaseHistory: 'ប្រវត្តិការទិញ',
    personalInfo: 'ព័ត៌មានផ្ទាល់ខ្លួន',
    cutlery: 'សម្ភារៈញ៉ាំអាហារ',
    km: 'គម',
    totalAmountSum: 'សរុប',
    selectedItemList: 'ទំនិញដែលបានជ្រើសរើស',
    iAm: 'ខ្ញុំ',
    orderedBy: 'បញ្ជាទិញដោយ',
    shareQRtoFriend: 'ចែករំលែក QR Code',
    share: 'ចែករំលែក',
    hasItemInBasket: 'មានទំនិញក្នុងកន្រ្ដក',
    hasItemInBasketDespt: 'កុំភ្លេចផ្ញើទៅផ្ទះបាយ',
    updatedAtQR: 'ធ្វើបច្ចុប្បន្នភាពនៅ',
    orderSent: 'បានផ្ញើការបញ្ជាទិញទៅផ្ទះបាយ',
    orderSentDespt: 'ភោជនីយដ្ឋានកំពុងរៀបចំអាហាររបស់អ្នក',
    checkGramdTotalIn: 'អ្នកអាចពិនិត្យមើលចំនួនសរុបនៅ',
    vatNotInclude: 'តម្លៃនេះមិនរួមបញ្ចូលពន្ធ ថ្លៃសេវា និងការបញ្ចុះតម្លៃទេ',
    accept: 'យល់ព្រម',
    termOfService: 'លក្ខខណ្ឌនៃសេវាកម្ម',
    onPending: 'កំពុងរង់ចាំ',
    OnSuccessOrder: 'ជោគជ័យ',
    prepareingOrder: 'កំពុងរៀបចំការបញ្ជាទិញ',
    deliveringOrder: 'កំពុងដឹកជញ្ជូន',
    pickupOrderReady: 'រួចរាល់សម្រាប់ទទួល',
    pickedupOrder: 'បានទទួលហើយ',
    deliveredOrder: 'ដឹកជញ្ជូនជោគជ័យ',
    shopReceivedOrder: 'ហាងបានទទួលការបញ្ជាទិញ',
    orderId: 'លេខសម្គាល់ការបញ្ជាទិញ',
    orderDetails: 'ព័ត៌មានលម្អិតការបញ្ជាទិញ',
    deliveryFee: 'ថ្លៃដឹកជញ្ជូន',
    searchDriver: 'កំពុងស្វែងរកអ្នកបើកបរ',
    driverFrom: 'អ្នកបើកបរពី',
    change: 'ផ្លាស់ប្ដូរ',
    deliveryAddress: 'អាសយដ្ឋានដឹកជញ្ជូន',
    location: 'ទីតាំង',
    addressName: 'ឈ្មោះអាសយដ្ឋាន',
    addressNameDespt: 'ឧទា. ឈ្មោះខុនដូ ឈ្មោះភូមិ',
    addressDescription: 'ព័ត៌មានលម្អិតអាសយដ្ឋាន',
    addressDescriptionDespt: 'ឧទា. លេខអគារ ផ្លូវ',
    noteToDriver: 'កំណត់ចំណាំទៅអ្នកបើកបរ',
    noteToDriverDespt: 'ឧទា. ដាក់នៅលើតុមុខទ្វារ',
    inputAddressForm: 'បញ្ចូលអាសយដ្ឋានដឹកជញ្ជូន',
    plsPinAddress: 'កំណត់ទីតាំងរបស់អ្នក',
    pinLocation: 'កំណត់ទីតាំងដឹកជញ្ជូន',
    createNewAddress: 'បង្កើតអាសយដ្ឋានថ្មី',
    savedAddress: 'អាសយដ្ឋានដែលបានរក្សាទុក',
    phoneNumber: 'លេខទូរសព្ទ',
    noRequired: 'ស្រេចចិត្ត',
    resendCode: 'ផ្ញើកូដម្ដងទៀត',
    didNotGetCode: 'មិនទទួលបានកូដ?',
    resendIn: 'ផ្ញើម្ដងទៀតក្នុង',
    next: 'បន្ទាប់',
    createAccount: 'បង្កើតគណនី',
    createAccountDespt: 'បំពេញទម្រង់ខាងក្រោមដើម្បីបង្កើតគណនី',
    sendCodeViaSMS: 'ផ្ញើកូដតាម SMS',
    inputOTP: 'បញ្ចូល OTP',
    inputOTPDespt: 'សូមបញ្ចូលកូដ 6 ខ្ទង់ដែលបានផ្ញើទៅ',
    termAndPolicy: 'លក្ខខណ្ឌ និងគោលនយោបាយ',
    termAndPolicy1: 'ដោយប្រើសេវាកម្មរបស់យើង អ្នកយល់ព្រមតាម',
    termAndPolicy2: 'ចុចដើម្បីអានលក្ខខណ្ឌ និងគោលនយោបាយទាំងអស់',

    loginWithPhoneNumber: 'ចូលដោយលេខទូរសព្ទ',
    loginWithPhoneNumberDespt: 'បញ្ចូលលេខទូរសព្ទរបស់អ្នកដើម្បីទទួល OTP សម្រាប់ផ្ទៀងផ្ទាត់អត្តសញ្ញាណ',
    backToOrder: 'ត្រឡប់ទៅម៉ឺនុយ',
    PaymentMethod: 'ការទូទាត់',
    paymentAmount: 'ចំនួនទឹកប្រាក់ទូទាត់',
    paymentConfirmation: 'ការបញ្ជាក់ការទូទាត់',
    cancelPayment: 'បោះបង់ការទូទាត់',
    paidSuccess: 'ទូទាត់ជោគជ័យ',
    haveNotPurchased: 'មិនទាន់បានទិញទេ',
    haveNotPurchased2: 'ប្រសិនបើការទូទាត់បរាជ័យ សូមទាក់ទងបុគ្គលិក',
    canNotOrderItem: 'អ្នកមិនអាចបញ្ជាទិញអាហារពេលកំពុងទូទាត់បានទេ',
    checkPaymentStatus: 'ពិនិត្យស្ថានភាព',
    pendingPayment: 'ការទូទាត់កំពុងរង់ចាំ',
    askForReceipt: 'ប្រសិនបើអ្នកត្រូវការវិក្កយបត្រ សូមទាក់ទងបុគ្គលិក',
    paymentSuccess: 'ទូទាត់ជោគជ័យ',
    summaryPayment: 'សង្ខេប',
    numberOfGuest: 'ចំនួនភ្ញៀវ',
    closeTab: 'បិទ',
    addCredit: 'បន្ថែមកាតឥណទាន',
    QRPayment: 'ទូទាត់ QR',
    cardPayment: 'កាតឥណទាន',
    payWithStaff: 'ទូទាត់នៅបញ្ជរ',
    selectPaymentMethod: 'ជ្រើសរើសវិធីទូទាត់',
    checkOut: 'គិតលុយ',
    startOrderBeforeCallStaff: 'សូមបញ្ជាទិញអាហារមុនពេលហៅបុគ្គលិក',
    basket: 'កន្រ្ដក',
    spoon: 'ស្នើសុំសម្ភារៈញ៉ាំអាហារ',
    knife: 'ស្នើសុំកាំបិត',
    chopstick: 'ស្នើសុំចង្កឹះ',
    cup: 'ស្នើសុំពែង',
    plate: 'ស្នើសុំចាន',
    glass: 'ស្នើសុំកែវ',
    payBill: 'ស្នើសុំគិតលុយ',
    viewAll: 'មើលទាំងអស់',
    recommendMenu: 'ណែនាំ',
    OnSuccess: 'ជោគជ័យ',
    OnPreparing: 'កំពុងរៀបចំ',
    messageSent: 'សូមរង់ចាំបុគ្គលិករបស់យើង',
    outOfStock: 'អស់ស្តុក',
    QRCode: 'QR Code',
    GenerateQRCode: 'បង្កើត QR Code',
    ForQROrder: 'សម្រាប់បញ្ជាទិញអាហារ និងស្នើសុំសេវាក្នុងហាង',
    QROrderDescription: 'អ្នកអាចបង្កើត QR Code សម្រាប់អតិថិជនស្កេនដើម្បីបញ្ជាទិញអាហារ និងស្នើសុំសេវាក្នុងហាង',
    SelectTable: 'ជ្រើសរើសតុ និងបញ្ចូលចំនួនភ្ញៀវ។',
    shopname: 'ឈ្មោះហាង',
    numberOfCustomer: 'ចំនួនអតិថិជន (នាក់)',
    numberOfCustomerDescription: 'បញ្ចូលចំនួនអតិថិជន យ៉ាងតិច 1 នាក់',
    currentUser: 'អ្នកប្រើ',
    guest: 'ភ្ញៀវ',
    orderItem: 'សង្ខេបការបញ្ជាទិញ',
    orderItemNav: 'សង្ខេបការបញ្ជាទិញ',
    callStaff: 'ហៅបុគ្គលិក',
    callStaffDialog: 'តើអ្នកត្រូវការជំនួយអ្វី?',
    cutlery: 'ស្នើសុំសម្ភារៈញ៉ាំអាហារ',
    seasoning: 'ស្នើសុំគ្រឿងផ្សំ',
    refillDrink: 'ស្នើសុំបន្ថែមភេសជ្ជៈ',
    other: 'ផ្សេងៗ',
    tableNumber: 'តុ',
    menuList: 'ម៉ឺនុយ',
    selectedItem: 'បញ្ជាទិញអាហារ',
    selectedItemNav: 'បញ្ជាទិញអាហារ',
    checkOrderBeforeConfirm: 'សូមពិនិត្យព័ត៌មានលម្អិតនៃការបញ្ជាទិញ និងចំនួនសរុបមុនពេលផ្ញើទៅភោជនីយដ្ឋាន',
    checkOrderBeforeConfirm2: '',
    startOrder: 'ចាប់ផ្ដើមបញ្ជាទិញ',
    foodCategory: 'ប្រភេទ',
    searchByName: 'ស្វែងរកផលិតផលតាមឈ្មោះ...',
    noPreduct: 'គ្មានផលិតផល',
    noSelectedProduct: 'គ្មានទំនិញដែលបានជ្រើសរើស',
    noSelectedProductDespt: 'ប្រសិនបើអ្នកបានជ្រើសរើសផលិតផល បញ្ជីនឹងបង្ហាញនៅទំព័រនេះ',
    backToMenu: 'ទៅម៉ឺនុយ',
    removeSelected: 'តើអ្នកចង់លុបទំនិញនេះទេ?',
    confirmOrder: 'ផ្ញើការបញ្ជាទិញ',
    endOfTransection: 'បញ្ចប់ប្រតិបត្តិការ',
    endOfTransectionDialog: 'ក្នុងករណីមានបញ្ហា សូមទាក់ទងបុគ្គលិក',
    note: 'កំណត់ចំណាំ',
    orderTime: 'ម៉ោងបញ្ជាទិញ',
    orderMoreFood: 'ត្រឡប់ទៅម៉ឺនុយមេ',
    orderPreparing: 'ចុងភៅរបស់យើងកំពុងរៀបចំអាហាររបស់អ្នក។ សូមរង់ចាំបន្ដិច។ អាហាររបស់អ្នកនឹងមកដល់ក្នុងពេលឆាប់ៗ',
    orderPreparing2: '',
    sendingOrder: 'កំពុងផ្ញើការបញ្ជាទិញទៅផ្ទះបាយ...',
    login: 'ចូល',
    forgetPassword: 'ភ្លេចពាក្យសម្ងាត់',
    loginWithGmail: 'ចូលដោយ Gmail',
    or: 'ឬ',
    loginAsStaff: 'ចូលជាបុគ្គលិក',
    billOrder: 'វិក្កយបត្រ',
    table: 'តុ',
    billOrderDialog: 'ស្កេន QR Code ដើម្បីមើលម៉ឺនុយ និងបញ្ជាទិញ',
    billOrderDialog2: 'ក្នុងករណីមានបញ្ហា សូមទាក់ទងបុគ្គលិក',
    selectTableAleart: 'សូមជ្រើសរើសតុមុនពេលបង្កើត QR Code',
    emptyCartDialog: 'គ្មានប្រតិបត្តិការ',
    emptyCartDialogDespt: 'ប្រសិនបើអ្នកបញ្ជាក់ការបញ្ជាទិញ បញ្ជីនឹងបង្ហាញនៅទំព័រនេះ',
    served: 'បម្រើរួច',
    contactOurStaff: 'ទាក់ទងបុគ្គលិក',
    contactOurStaff2: 'ក្នុងករណីត្រូវការជំនួយ',
    addToCart: 'ដាក់ក្នុងកន្រ្ដក',
    noteToShop: 'កំណត់ចំណាំទៅហាង',
    addYourRequest: 'បន្ថែមសំណើរបស់អ្នក',
    branchName: 'ឈ្មោះសាខា',
    businessType: 'ប្រភេទអាជីវកម្ម',
    taxID: 'លេខអត្តសញ្ញាណពន្ធ',
    vat: 'ពន្ធ',
    exclusive: 'មិនរួមពន្ធ',
    inclusive: 'រួមពន្ធ',
    serviceCharge: 'ថ្លៃសេវា',
    address: 'អាសយដ្ឋាន',
    address1: 'អាសយដ្ឋានទី 1',
    address2: 'អាសយដ្ឋានទី 2',
    tel: 'ទូរសព្ទ',
    businessType1: 'ទូទៅ',
    businessType2: 'ភោជនីយដ្ឋាន',
    businessType3: 'ផ្ទះសំណាក់',
    shopopen: 'បើក - បិទ',
    open: 'បើក',
    closed: 'បិទ',
    languagetxt: 'ភាសា',
    language: 'ភាសា និងតំបន់ម៉ោង',
    languageTH: 'ថៃ',
    languageEN: 'អង់គ្លេស',
    setting: 'ការកំណត់',
    shop: 'ហាង',
    timezone: 'តំបន់ម៉ោង',
    deliveryProviders: 'អ្នកផ្ដល់សេវាដឹកជញ្ជូន',
    adddeliveryProviders: 'បន្ថែមអ្នកផ្ដល់សេវា',
    lastUpdate: 'ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ',
    logo: 'ឡូហ្គោ',
    updateData: 'ធ្វើបច្ចុប្បន្នភាពទិន្នន័យ',
    submit: 'ដាក់ស្នើ',
    cancel: 'បោះបង់',
    normal: 'ធម្មតា',
    loading: 'កំពុងផ្ទុក...',
    editing: 'កំពុងកែសម្រួល',
    confirmUpdate: 'តើអ្នកចង់ធ្វើបច្ចុប្បន្នភាពទិន្នន័យទេ?',
    selectedShoptype: 'ជ្រើសរើសប្រភេទអាជីវកម្ម...',
    selectshop: 'ជ្រើសរើសឈ្មោះសាខា',
    save: 'រក្សាទុក',
    reporttxt: 'របាយការណ៍',
    general: 'ទូទៅ',
    signOut: 'ចាកចេញ',
    registration: '',
    unit: 'ឯកតា',
    category: 'ប្រភេទ',
    product: 'ផលិតផល',
    export: 'នាំចេញ',
    exportKBank: 'នាំចេញ K-Bank',
    date: 'កាលបរិច្ឆេទ',
    to: 'ដល់',
    status: 'ស្ថានភាព',
    vatAmount: 'ពន្ធ',
    netTotalNonVAT: 'សរុប (មិនរួមពន្ធ)',
    receiptNumber: 'លេខវិក្កយបត្រ',
    grandTotal: 'សរុបទាំងអស់',
    netAmountVATTotal: 'សរុបរង',
    netTotalIncVAT: 'សរុប (រួមពន្ធ)',
    proofOfPayment: 'ភស្តុតាងការទូទាត់',
    paymentType: 'ប្រភេទការទូទាត់',
    paymentType0: 'សាច់ប្រាក់',
    paymentType1: 'កាតឥណទាន',
    paymentType2: 'គូប៉ុង',
    paymentType3: 'Quickpay',
    paymentType4: 'Promptpay',
    paymentType5: 'Alipay',
    paymentType6: 'ប្រាក់កក់',
    paymentType7: 'ដឹកជញ្ជូន',
    paymentType8: 'អនឡាញ',
    paymentType9: 'Line Pay',
    paymentType10: 'ការទូទាត់ផ្ទាល់ខ្លួន',
    paymentType12: 'KBank',
    paid: 'តម្លៃទូទាត់',
    sentSuccessfully: 'ផ្ញើជោគជ័យ',
    pluCode: 'បាកូដ',
    netAmount: 'សរុបសុទ្ធ',
    discount: 'ការបញ្ចុះតម្លៃ',
    timeOfOrder: 'ម៉ោងបញ្ជាទិញ',
    orderDate: 'កាលបរិច្ឆេទបញ្ជាទិញ',
    preparing: 'កំពុងរៀបចំ',
    paymentDetail: 'ព័ត៌មានលម្អិតការទូទាត់',
    orderNumber: 'លេខបញ្ជាទិញ',
    delivered: 'កាលកំណត់',
    deliveredDate: 'រយៈពេលដឹកជញ្ជូន',
    payment: 'ការទូទាត់',
    productName: 'ឈ្មោះផលិតផល',
    quantity: 'បរិមាណ',
    priceUnit: 'តម្លៃ/ឯកតា',
    baht: 'បាត',
    profit: 'ប្រាក់ចំណេញ',
    sales: 'ការលក់',
    billAmount: 'វិក្កយបត្រសរុប',
    total: 'សរុប',
    bill: 'វិក្កយបត្រ',
    discountAmount: 'ចំនួនបញ្ចុះតម្លៃ',
    averageBill: 'មធ្យម/វិក្កយបត្រ',
    voidbillTotal: 'វិក្កយបត្រលុបចោលសរុប',
    salesByDaily: 'ការលក់តាមថ្ងៃ',
    salesByMonth: 'ការលក់តាមខែ',
    bestSellers: 'ផលិតផលលក់ដាច់បំផុត',
    bestSellerstype: 'ប្រភេទលក់ដាច់បំផុត',
    salesBydate: 'ការលក់តាមកាលបរិច្ឆេទ',
    number: 'លេខ',
    categoryName: 'ឈ្មោះប្រភេទ',
    newOrder: 'ផ្ញើការបញ្ជាទិញ',
    reject: 'បដិសេធ',
    inProgressTime: 'រយៈពេលដំណើរការ',
    rejectTime: 'ម៉ោងបដិសេធ',
    cancelTime: 'ម៉ោងបោះបង់',
    cause: 'មូលហេតុ',
    preparingToShip: 'កំពុងរៀបចំ',
    totalAmount: 'សរុប',
    order: 'ការបញ្ជាទិញ',
    deposit: 'ប្រាក់កក់',
    billSave: 'រក្សាទុក',
    ReceivingOrder: 'បើកតុ/ទទួលការបញ្ជាទិញ',
    orderNo: 'លេខបញ្ជាទិញ',
    remark: 'កំណត់សម្គាល់',
    receiptStatus: 'ស្ថានភាពវិក្កយបត្រ',
    back: 'ត្រឡប់',
    detail: 'ព័ត៌មានលម្អិត',
    countSales: 'បរិមាណ',
    onhandQty: 'សមតុល្យ',
    stdCost: 'ថ្លៃដើម',
    employees: 'បុគ្គលិក',
    employeesname: 'ឈ្មោះបុគ្គលិក',
    salesTotal: 'ការលក់សរុប',
    totalBill: 'ចំនួនវិក្កយបត្រទាំងអស់',
    billActive: 'ចំនួនវិក្កយបត្រលក់',
    billVoice: 'ចំនួនវិក្កយបត្រលុបចោល',
    billDeposit: 'ចំនួនវិក្កយបត្រកក់',
    discountItem: 'ការបញ្ចុះតម្លៃទំនិញសរុប',
    billDiscountAmount: 'ការបញ្ចុះតម្លៃវិក្កយបត្រសរុប',
    billDiscount: 'ចំនួនវិក្កយបត្របញ្ចុះតម្លៃ',
    payTotal: 'ការទូទាត់សរុប',
    deliveryProvider: 'អ្នកផ្ដល់សេវាដឹកជញ្ជូន',
    deliveryDetail: 'ព័ត៌មានលម្អិតដឹកជញ្ជូន',
    customDetail: 'ព័ត៌មានលម្អិតការទូទាត់ផ្ទាល់ខ្លួន',
    customPaymentName: 'ឈ្មោះការទូទាត់ផ្ទាល់ខ្លួន',
    firstInvoiceNO: 'លេខវិក្កយបត្រដំបូង',
    lastInvoiceNO: 'លេខវិក្កយបត្រចុងក្រោយ',
    roundNo: 'លេខវគ្គ',
    closeAt: 'បិទនៅម៉ោង',
    closeBy: 'បិទដោយ',
    totalCashSales: 'ការលក់សាច់ប្រាក់សរុប',
    initialChange: 'ប្រាក់រាប់ដំបូង',
    totalCashIn: 'សាច់ប្រាក់ចូលសរុប',
    totalCashOut: 'សាច់ប្រាក់ចេញសរុប',
    actualInDrawer: 'ចំនួនពិតក្នុងថត',
    expectedInDrawer: 'ចំនួនរំពឹងទុកក្នុងថត',
    difference: 'ភាពខុសគ្នា',
    voidBillDetail: 'ព័ត៌មានលម្អិតវិក្កយបត្រលុបចោល',
    cancelBy: 'បោះបង់ដោយ',
    cancelDate: 'កាលបរិច្ឆេទបោះបង់',
    searchByEmployees: 'ស្វែងរកតាមបុគ្គលិក',
    search: 'ស្វែងរក',
    timeIn: 'ម៉ោងចូល',
    timeOut: 'ម៉ោងចេញ',
    time: 'ម៉ោង',
    hours: 'ម៉ោង',
    seconds: 'វិនាទី',
    netTotal: 'សរុប',
    reason: 'មូលហេតុ',
    searchByProduct: 'ស្វែងរកតាមផលិតផល',
    sortBy: 'តម្រៀបតាម',
    last: 'ចុងក្រោយ',
    price: 'តម្លៃផលិតផល',
    sortByNumMin: 'តម្លៃទាបបំផុត',
    sortByNumMax: 'តម្លៃខ្ពស់បំផុត',
    documentNo: 'លេខឯកសារ',
    transactionType: 'ប្រភេទប្រតិបត្តិការ',
    updatedBy: 'ធ្វើបច្ចុប្បន្នភាពដោយ',
    transactionType1: 'លក់',
    transactionType2: 'សងប្រាក់វិញ',
    transactionType3: 'ស្តុកចូល',
    transactionType4: 'ស្តុកចេញ',
    transactionType5: 'កែតម្រូវស្តុកចូល',
    transactionType6: 'កែតម្រូវស្តុកចេញ',
    transactionType7: 'បដូរពិន្ទុ',
    transactionType8: 'លុបស្តុកចូល',
    transactionType9: 'លុបស្តុកចេញ',
    transactionType10: 'កែស្តុកចូល',
    transactionType11: 'កែស្តុកចេញ',
    billNo: 'លេខវិក្កយបត្រ',
    docTotal: 'សរុប',
    customer: 'អតិថិជន',
    username: 'ឈ្មោះអ្នកប្រើ',
    dateOfBill: 'កាលបរិច្ឆេទវិក្កយបត្រ',
    selectDate: 'ជ្រើសរើសកាលបរិច្ឆេទ',
    dialogSelectCategory: 'សូមជ្រើសរើសប្រភេទដើម្បីស្វែងរក',
    dialogUpdateDocumentSuccess: 'ធ្វើបច្ចុប្បន្នភាពឯកសារជោគជ័យ',
    dialogfound: 'ព័ត៌មានដែលបានបញ្ចូលមិនត្រឹមត្រូវ។',
    isVatIncluded: 'រួមបញ្ចូល VAT ដែរទេ',
    vatIccludes: 'VAT',
    confirmStock: 'បញ្ជាក់ស្តុក',
    confirm: 'បញ្ជាក់',
    deleteDoc: 'លុបឯកសារ',
    confirmUpdateDocModal: 'តើអ្នកចង់ធ្វើបច្ចុប្បន្នភាពឯកសារស្តុកទេ?',
    confirmSaveDoc: 'បញ្ជាក់ការរក្សាទុកឯកសារ',
    confirmDeleteDoc: 'បញ្ជាក់ការលុបឯកសារ',
    confirmDeleteModal: 'តើអ្នកចង់លុបឯកសារស្តុកទេ?',
    dialogSaveDocumentSuccess: 'រក្សាទុកឯកសារជោគជ័យ',
    createStockIn: 'បង្កើតស្តុកចូល',
    confirmSaveDocModal: 'តើអ្នកចង់រក្សាទុកឯកសារស្តុកទេ?',
    selectShopPlease: 'សូមជ្រើសរើសហាង',
    selectProductPlease: 'សូមជ្រើសរើសផលិតផល',
    duplicateProduct: 'អ្នកបានជ្រើសរើសទំនិញនេះរួចហើយ។',
    productInvilid: 'ទំនិញដែលអ្នកជ្រើសរើសមិនមានសុពលភាព។ សូមទាក់ទងអ្នកគ្រប់គ្រងប្រព័ន្ធ។',
    confirmStockOut: 'បញ្ជាក់ស្តុកចេញ',
    dialogSaveDocumentOutSuccess: 'រក្សាទុកឯកសារជោគជ័យ',
    confirmSaveDocStockOutModal: 'តើអ្នកចង់រក្សាទុកឯកសារស្តុកចេញទេ?',
    adjustDocType: 'ប្រភេទឯកសារកែតម្រូវ',
    adjustDocType1: 'បង្កើន',
    adjustDocType2: 'បន្ថយ',
    beforeAdjust: 'មុនកែតម្រូវស្តុក',
    afterAdjust: 'ក្រោយកែតម្រូវស្តុក',
    adjust: 'កែតម្រូវស្តុក',
    createDoucument: 'បង្កើតឯកសារ',
    transferType: 'ប្រភេទផ្ទេរ',
    transferType1: 'ផ្ទេរចូល',
    transferType2: 'ផ្ទេរចេញ',
    new: 'ថ្មី',
    finish: 'រួចរាល់',
    refDocument: 'ឯកសារយោង',
    statusDoc: 'ស្ថានភាពឯកសារ',
    dialogSaveTransferDocumentSuccess: 'បង្កើតឯកសារផ្ទេរជោគជ័យ',
    destinationShop: 'ហាងគោលដៅ',
    destinationShopBranch: 'សាខាគោលដៅ',
    sourceBranch: 'សាខាប្រភព',
    sourceShop: 'ហាងប្រភព',
    sourceAddress: 'អាសយដ្ឋានប្រភព',
    destinationAddress: 'អាសយដ្ឋានគោលដៅ',
    saveTransfer: 'រក្សាទុកការផ្ទេរស្តុក',
    confirmSaveTransfer: 'តើអ្នកចង់រក្សាទុកការផ្ទេរស្តុកទេ?',
    savinserviceChargegDoc: 'កំពុងរក្សាទុកឯកសារ',
    selectdestinationPlease: 'សូមជ្រើសរើសសាខាគោលដៅ',
    validatedestinationproduct: "សាខាគោលដៅមិនមានផលិតផលនេះទេ",
    validateProduct: 'សូមជ្រើសរើសផលិតផល',
    created_by: 'ដោយ',
    receive: 'ទទួល',
    updateDoc: 'ធ្វើបច្ចុប្បន្នភាពឯកសារ',
    cancelDoc: 'បោះបង់ឯកសារ',
    confirmCancelDoc: 'តើអ្នកចង់បោះបង់ឯកសារនេះទេ?',
    cancelingDoc: 'កំពុងបោះបង់ឯកសារ',
    updatingDoc: 'កំពុងធ្វើបច្ចុប្បន្នភាពឯកសារ',
    updateDocFail: "មិនអាចធ្វើបច្ចុប្បន្នភាពឯកសារបានទេ",
    cancelDocSuccess: 'បោះបង់ឯកសារជោគជ័យ',
    cancelDocFail: "មិនអាចបោះបង់ឯកសារបានទេ",
    refDocumentTransfer: 'ឯកសារយោង',
    comfrimTransferIn: 'បញ្ជាក់ការផ្ទេរស្តុកចូល',
    dilogcomfrimTransferIn: 'តើអ្នកចង់ផ្ទេរស្តុកចូលឯកសារទេ?',
    transferInDetail: 'ព័ត៌មានលម្អិតការផ្ទេរស្តុក',
    totalNet: 'សរុបសុទ្ធ',
    confirmAdjust: 'បញ្ជាក់ការកែតម្រូវស្តុក',
    createStockOut: 'បង្កើតស្តុកចេញ',
    favorite: 'ចំណូលចិត្ត',
    isOnScreen: 'បង្ហាញលើអេក្រង់',
    negotiatePrice: 'ចរចាតម្លៃ',
    productTypeP: 'ផលិតផលទូទៅ',
    productTypeBOM: 'វត្ថុធាតុដើម',
    productTypeSN: 'ផលិតផលស៊េរី',
    productTypeSV: 'សេវាកម្ម (គ្មានស្តុក)',
    productPLU: 'ទំហំកញ្ចប់ផ្សេងៗ',
    productBOM: 'វត្ថុធាតុដើម',
    productSN: 'Serial Number',
    morePrice: 'តម្លៃផ្សេងៗ',
    cost: 'ថ្លៃដើម',
    quantityPrice: 'បរិមាណ',
    exceedUc: 'តម្លៃ',
    changeImg: 'ផ្លាស់ប្ដូររូបភាព',
    addProduct: 'បន្ថែមផលិតផល',
    selectImg: 'ជ្រើសរើសរូបភាព',
    deleteImg: 'លុបរូបភាព',
    selectImgFromPC: 'ជ្រើសរើសរូបភាពពីកុំព្យូទ័រ',
    confirmSaveImgDialog: 'តើអ្នកចង់រក្សាទុកផលិតផលទេ?',
    confirmSaveImg: 'បញ្ជាក់ការរក្សាទុកផលិតផល',
    addPrice: 'បន្ថែមតម្លៃ',
    editPrice: 'កែសម្រួលតម្លៃ',
    dialigDeleteProduct: 'តើអ្នកចង់លុបផលិតផលទេ?',
    confirmDeleteProduct: 'បញ្ជាក់ការលុបផលិតផលនេះ',
    productType: 'ប្រភេទផលិតផល',
    countProduct: 'ចំនួនផលិតផល',
    addUnit: 'បន្ថែមឯកតា',
    editUnit: 'កែសម្រួលឯកតា',
    active: 'សកម្ម',
    inactive: 'អសកម្ម',
    confirmSaveUnitDialog: 'តើអ្នកចង់រក្សាទុកឯកតាទេ?',
    confirmSaveUnit: 'បញ្ជាក់ការរក្សាទុកឯកតានេះ',
    dialigDeleteUnit: 'តើអ្នកចង់លុបឯកតាទេ?',
    confirmDeletUnit: 'បញ្ជាក់ការលុបឯកតានេះ',
    confirmSaveCategoryDialog: 'តើអ្នកចង់រក្សាទុកប្រភេទទេ?',
    confirmSaveCategory: 'បញ្ជាក់ការរក្សាទុកប្រភេទនេះ',
    dialigDeleteCategory: 'តើអ្នកចង់លុបប្រភេទទេ?',
    confirmDeletCategory: 'បញ្ជាក់ការលុបប្រភេទ',
    addCategory: 'បន្ថែមប្រភេទ',
    editCategory: 'កែសម្រួលប្រភេទ',
    bgColor: 'ពណ៌ផ្ទៃខាងក្រោយ',
    selectbgColor: 'ជ្រើសរើសពណ៌ផ្ទៃខាងក្រោយ',
    validateCategoryname: 'សូមបញ្ចូលឈ្មោះប្រភេទ។',
    sequence: 'លំដាប់',
    enterProduct: 'សូមបញ្ចូលឈ្មោះផលិតផល។',
    enterPrice: 'សូមបញ្ចូលតម្លៃផលិតផល។',
    selectCategory: 'សូមជ្រើសរើសប្រភេទផលិតផល។',
    selectUnit: 'សូមជ្រើសរើសឯកតាផលិតផល។',
    confirmSaveProduct: 'តើអ្នកចង់រក្សាទុកផលិតផលនេះទេ?',
    confirmSaveProductPrice: 'តើអ្នកចង់រក្សាទុកតម្លៃផ្សេងទេ?',
    validatepackQty: 'សូមបញ្ចូលតម្លៃ/ឯកតា។',
    validatepackUc: 'សូមបញ្ចូលតម្លៃ។',
    validatePRU: 'ទិន្នន័យស្ទួន សូមបញ្ចូលម្ដងទៀត។',
    createProductSuccess: 'បង្កើតផលិតផលជោគជ័យ',
    addSerial: 'បន្ថែមស៊េរី',
    add: 'បន្ថែម',
    createSerial: 'បង្កើត Serial Number',
    available: 'រួចរាល់សម្រាប់លក់',
    soldOut: 'អស់ស្តុក',
    deleteSuccess: 'លុបជោគជ័យ',
    enterSerial: 'សូមបញ្ចូល Serial Number',
    confirmSaveSerial: 'តើអ្នកចង់រក្សាទុក Serial Number នេះទេ?',
    confirmDelete: 'តើអ្នកចង់លុប Serial Number នេះទេ?',
    addProductPLU: 'បន្ថែមទំហំកញ្ចប់',
    img: 'រូបភាព',
    SKURatio: 'សមាមាត្រ',
    editProductPLU: 'កែសម្រួលទំហំកញ្ចប់',
    enterSKURatio: 'សូមបញ្ចូលសមាមាត្រ',
    comfrimDeletePLU: 'តើអ្នកចង់លុបទំហំកញ្ចប់នេះទេ?',
    useStepPrice: 'ប្រើតម្លៃជាកម្រិត',
    addBOM: 'បន្ថែមវត្ថុធាតុដើម',
    confirmSaveBOM: 'តើអ្នកចង់រក្សាទុកវត្ថុធាតុដើមទេ?',
    user: 'អ្នកប្រើ',
    userDetail: 'ព័ត៌មានលម្អិតអ្នកប្រើ',
    planDetail: 'ព័ត៌មានលម្អិតគម្រោង',
    currentPlan: 'គម្រោងបច្ចុប្បន្ន',
    expireDate: 'កាលបរិច្ឆេទផុតកំណត់',
    startDate: 'កាលបរិច្ឆេទចាប់ផ្ដើម',
    dialogSignOut: 'តើអ្នកចង់ចាកចេញទេ?',
    confirmSignOut: 'បញ្ជាក់ការចាកចេញ',
    countMember: 'សមាជិកទាំងអស់',
    addMenber: 'បន្ថែមសមាជិក',
    searchMember: 'ស្វែងរកតាមឈ្មោះ អ៊ីមែល និងទូរសព្ទ',
    dateOfMember: 'កាលបរិច្ឆេទសមាជិក',
    recentVisit: 'ការចូលមើលថ្មីៗ',
    memberName: 'ឈ្មោះសមាជិក',
    email: 'អ៊ីមែល',
    paymentTotal: 'ការទូទាត់សរុប',
    point: 'ពិន្ទុ',
    pointtxt: 'ពិន្ទុ',
    postalCode: 'លេខកូដប្រៃសណីយ៍',
    saveing: 'កំពុងរក្សាទុក...',
    edit: 'កែសម្រួល',
    editMember: 'កែសម្រួលសមាជិក',
    deleteing: 'កំពុងលុប...',
    dialogDeleteMember: 'តើអ្នកចង់លុបសមាជិកទេ?',
    confirmDeleteMember: 'បញ្ជាក់ការលុប',
    valtdateMember: 'សូមបំពេញព័ត៌មាន',
    createMemberSuccess: 'បន្ថែមសមាជិកជោគជ័យ!',
    updateMemberSuccess: 'កែសម្រួលសមាជិកជោគជ័យ!',
    deleteMemberSuccess: 'លុបសមាជិកជោគជ័យ!',
    onhandQtyMin: 'ស្តុកអប្បបរមា',
    onhandQtyMax: 'ស្តុកអតិបរមា',
    onhandQtySort: 'បរិមាណស្តុក',
    showProductAll: 'ផលិតផលគ្រប់ប្រភេទ',
    updateAt: 'ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ',
    sortName: 'ឈ្មោះ',
    stockUnit: 'ថ្លៃដើម/ឯកតា',
    deleteCategory: 'លុបប្រភេទ',
    selectd: 'ជ្រើសរើស',
    searchProduct: 'ស្វែងរកផលិតផល',
    reset: 'កំណត់ឡើងវិញ',
    selectdProduct: 'ជ្រើសរើសផលិតផល',
    information: 'ព័ត៌មាន',
    adjustStockList: 'ផលិតផលកែតម្រូវស្តុក',
    adjustDetail: 'បន្ថែមផលិតផលទៅបញ្ជីកែតម្រូវស្តុក និងកំណត់ផលិតផល',
    transferoutList: 'ផលិតផលផ្ទេរស្តុក',
    addProductTransfer: 'បន្ថែមផលិតផលទៅបញ្ជីផ្ទេរស្តុក និងកំណត់ផលិតផល',
    transferDetail: 'ផលិតផលទៅបញ្ជីស្តុកចេញ និងកំណត់ផលិតផល',
    transferinList: 'ផលិតផលទៅបញ្ជីស្តុកចូល និងកំណត់ផលិតផល',
    stockOutList: 'ផលិតផលស្តុកចេញ',
    addstockOutList: 'បន្ថែមផលិតផលទៅបញ្ជីស្តុកចេញ និងកំណត់ផលិតផល',
    stockinList: 'ផលិតផលស្តុកចូល',
    addProductStockin: 'បន្ថែមផលិតផលទៅបញ្ជីស្តុកចូល និងកំណត់ផលិតផល',
    checkCount: 'ពិនិត្យស្តុក',
    createAdjustStock: 'បង្កើតការកែតម្រូវស្តុក',
    memberDetail: 'ព័ត៌មានសមាជិក',
    package: 'ព័ត៌មានលម្អិតកញ្ចប់',
    startPackate: 'កញ្ចប់ចាប់ផ្ដើម',
    endPackate: 'កញ្ចប់បញ្ចប់',
    name: 'ឈ្មោះ',
    productImg: 'រូបភាពផលិតផល',
    fistname: 'នាមខ្លួន',
    lastname: 'នាមត្រកូល',
    saveMember: 'រក្សាទុកព័ត៌មាន',
    confirmSaveMember: 'តើអ្នកចង់រក្សាទុកសមាជិកទេ?',
    yesOrNo: 'បាទ/ទេ',
    totaValue: 'សរុប',
    deleteMember: 'លុបសមាជិក',
    frequently: 'ផលិតផលទិញញឹកញាប់',
    recentPurchase: 'ការទិញចុងក្រោយ',
    paymentDescription: 'ការពិពណ៌នាការទូទាត់',
    validateInfomation: 'សូមបញ្ចូលព័ត៌មាន',
    validateTel: 'លេខទូរសព្ទមិនត្រឹមត្រូវ',
    validateOTP: 'OTP មិនត្រឹមត្រូវ',
    validateEmail: 'អ៊ីមែលមិនត្រឹមត្រូវ',
    saveSuccess: 'រក្សាទុកជោគជ័យ',
    txtcustomer: 'អតិថិជន',
    customerName: 'ឈ្មោះអតិថិជន',
    customerCount: 'ចំនួនអតិថិជន',
    addCustomer: 'បន្ថែមអតិថិជន',
    permissionManage: 'សិទ្ធិ',
    mainMenu: 'ម៉ឺនុយមេ',
    page: 'ទំព័រ',
    show: 'បង្ហាញ',
    delete: 'លុប',
    administratorTools: 'ឧបករណ៍អ្នកគ្រប់គ្រង',
    deviceName: 'ឈ្មោះឧបករណ៍',
    lastSyncProduct: 'ធ្វើសមកាលកម្មចុងក្រោយ',
    version: 'កំណែ',
    posstatus: 'ស្ថានភាព',
    posNumber: 'លេខ POS',
    titleSilomconnect: 'កុំខកខានការលក់ជាមួយសេវាកម្មពី',
    updateSilom: 'ធ្វើបច្ចុប្បន្នភាពការលក់ប្រចាំថ្ងៃតាម LINE ដោយឥតគិតថ្លៃ',
    addfriend: 'បន្ថែមមិត្ត',
    enterToReciveService: 'ចុចដើម្បីទទួលកូដសម្រាប់ប្រើសេវាកម្ម។',
    verifyCodeToUsed: 'ដើម្បីចាប់ផ្ដើមប្រើប្រព័ន្ធ អ្នកអាចចុចទទួលកូដដើម្បីផ្ទៀងផ្ទាត់អត្តសញ្ញាណរបស់អ្នក។',
    verifyfivemin: 'កូដផ្ទៀងផ្ទាត់អាចប្រើបានក្នុងរយៈពេល 5 នាទី។',
    yourVertify: 'កូដផ្ទៀងផ្ទាត់របស់អ្នកគឺ',
    pressCode: 'ចុចទទួលកូដ',
    exCode: 'កូដផុតកំណត់ក្នុង',
    sessionEx: 'សម័យកាលចូលផុតកំណត់។ សូមចូលម្ដងទៀត។',
    refresh: 'ផ្ទុកឡើងវិញ',
    selectedFile: 'ជ្រើសរើសឯកសារ',
    fileSize: 'ទំហំឯកសារមិនលើស 2 MB។',
    isBeingToUsed: 'កំពុងប្រើ',
    notInUse: 'មិនកំពុងប្រើ',
    delete: 'លុប',
    confirmUpdateInformation: 'បញ្ជាក់ការធ្វើបច្ចុប្បន្នភាពព័ត៌មាន',
    memberCount: 'ចំនួន',
    orderMachine: 'ឧបករណ៍បញ្ជាទិញ',
    textMember: 'សមាជិក',
    manageShop: 'គ្រប់គ្រងព័ត៌មានហាង',
    lansetting: 'កំណត់ភាសា និងតំបន់ម៉ោងហាង',
    timezoneSetiing: 'កំណត់តំបន់ម៉ោងហាង',
    deliveryProviderSetting: 'អ្នកផ្ដល់សេវាដឹកជញ្ជូនសម្រាប់ហាង',
    toolsSetting: 'គ្រប់គ្រងម៉ាស៊ីន POS សម្រាប់ហាង',
    checkStockPLU: 'សមតុល្យផលិតផល < 0',
    searching: 'កំពុងស្វែងរក',
    allProduct: 'ផលិតផលទាំងអស់',
    foundProductOnhand: 'រកឃើញផលិតផលមានស្តុក < 0',
    confirmAdjustBefor: 'តើអ្នកចង់ឱ្យប្រព័ន្ធកែតម្រូវដោយស្វ័យប្រវត្តិទេ?',
    requireAdjust: 'បាទ/ចាស',
    imrequireAdjust: 'ទេ',
    islimitItemTodoc: 'អ្នកអាចជ្រើសរើសបានរហូតដល់ 200 ទំនិញ / 1 ឯកសារ។',
    barcodePrint: 'បោះពុម្ពបាកូដ',
    printEx: 'បោះពុម្ព និងឧទាហរណ៍',
    print: 'បោះពុម្ព',
    downloadAndExport: 'ទាញយក និងបោះពុម្ព',
    selectFormat: 'ជ្រើសរើសទម្រង់ក្រដាស',
    peperFormat: 'ទម្រង់ក្រដាស',
    optional: 'ជ្រើសរើស',
    standardA427: 'A4 ស្តង់ដារ: 27 ទំនិញ/ទំព័រ',
    standardA450: 'A4 ស្តង់ដារ: 52 ទំនិញ/ទំព័រ',
    standardA460: 'A4 ស្តង់ដារ: 60 ទំនិញ/ទំព័រ',
    standardA556: 'A4 ស្តង់ដារ: 56 ទំនិញ/ទំព័រ (ទំហំស្ទីកឃ័រ: A5)',
    standardA550: 'ក្រដាស A5: 52 ទំនិញ/ទំព័រ',
    standardA560: 'ក្រដាស A5: 60 ទំនិញ/ទំព័រ',
    countBarcode: 'ចំនួនបាកូដ',
    barcode: 'បាកូដ',
    setFontsize: 'កំណត់ពុម្ពអក្សរ',
    accessPermissionDes: 'ផ្ដល់សិទ្ធិចូលប្រើសម្រាប់អ្នកប្រើ។',
    deleteUser: 'បញ្ជាក់ការលុបអ្នកប្រើ',
    confirmDeleteUser: 'តើអ្នកចង់លុបអ្នកប្រើទេ?',
    passAtless: 'ពាក្យសម្ងាត់ត្រូវមានយ៉ាងតិច 6 តួអក្សរ។',
    inValidPass: 'ពាក្យសម្ងាត់មិនត្រឹមត្រូវ',
    createBy: 'បង្កើតដោយ',
    adjustAutoDes: "ប្រសិនបើអ្នកមិនចង់ឱ្យប្រព័ន្ធធ្វើបច្ចុប្បន្នភាពដោយស្វ័យប្រវត្តិ សមតុល្យសរុបនៃផលិតផលអាចមិនត្រឹមត្រូវ។",
    addUser: 'បន្ថែមអ្នកប្រើ',
    isMenu: 'បង្ហាញលើម៉ឺនុយសម្រាប់អតិថិជន',
    menuSmart: 'កំណត់ម៉ឺនុយផលិតផល',
    smartSettingTitle: 'កំណត់ម៉ឺនុយ',
    smartSetting: 'កំណត់ម៉ឺនុយសម្រាប់ Silom CRM',
    confirmEnable: 'តើអ្នកចង់បើកម៉ឺនុយទេ?',
    confirmDisEnable: 'តើអ្នកចង់បិទម៉ឺនុយទេ?',
    confirmSelfOrderEnable: 'តើអ្នកចង់បើកម៉ឺនុយបញ្ជាទិញដោយខ្លួនឯងទេ?',
    confirmSelfOrderDisable: 'តើអ្នកចង់បិទម៉ឺនុយបញ្ជាទិញដោយខ្លួនឯងទេ?',
    enable: 'បើក',
    disable: 'បិទ',
    usabilityStatus: 'បើក',
    manageSmartOnProduct: 'អ្នកអាច "បន្ថែម/កែសម្រួល" បញ្ជីផលិតផលដែលចង់បង្ហាញលើម៉ឺនុយអតិថិជននៅទំព័រ។',
    manageSmartOnCategory: 'អ្នកអាច "បន្ថែម/កែសម្រួល" បញ្ជីប្រភេទដែលចង់បង្ហាញលើម៉ឺនុយអតិថិជននៅទំព័រ។',
    turnonSmart: 'និងបើកម៉ឺនុយ',
    manageShopDes: 'អ្នកអាចយោងទៅសៀវភៅណែនាំអ្នកប្រើក្នុង -',
    desSmartMenu: 'កំណត់ម៉ឺនុយផលិតផលសម្រាប់បង្ហាញ E-menu នៅលើ LINE សម្រាប់ឱ្យអតិថិជនចូលប្រើ និងបញ្ជាទិញផលិតផលដោយខ្លួនឯង។',
    link: 'តំណ',
    createTranferOut: 'បង្កើតឯកសារផ្ទេរស្តុកចេញ',
    roundingValue: 'ការកែតម្រូវការបង្គត់',
    limitItems: 'អាចជ្រើសរើសផលិតផលបានរហូតដល់ 200 ទំនិញ',
    IncomeCategory: 'ចំណូល',
    ExpenseCategory: 'ចំណាយ',
    saveBy: 'រក្សាទុកដោយ',
    saveDate: 'កាលបរិច្ឆេទរក្សាទុក',
    drawerCate: 'ប្រភេទ',
    openingHours: 'ម៉ោងបើកដំណើរការ',
    shopLocation: 'ទីតាំងហាង',
    sunday: 'ថ្ងៃអាទិត្យ',
    monday: 'ថ្ងៃច័ន្ទ',
    tuesday: 'ថ្ងៃអង្គារ',
    wednesday: 'ថ្ងៃពុធ',
    thursday: 'ថ្ងៃព្រហស្បតិ៍',
    friday: 'ថ្ងៃសុក្រ',
    saturday: 'ថ្ងៃសៅរ៍',
    lat: 'រយៈទទឹង',
    lng: 'រយៈបណ្ដោយ',
    shopCoverSetting: 'កំណត់គម្របហាង',
    shopCoverSettingDes: 'កំណត់គម្របហាងសម្រាប់បង្ហាញលើអេក្រង់អតិថិជន',
    locationSettingDes: 'កំណត់ទីតាំង',
    updatelocation: 'ធ្វើបច្ចុប្បន្នភាពទីតាំង',
    searchLocation: 'ស្វែងរកទីតាំង',
    imaginaryLine: 'បន្ទាត់ស្រមើស្រមៃ',
    openingHoursDes: 'កំណត់ម៉ោងបើកដំណើរការហាង',
    paymentDescriptionConfig: 'ជ្រើសរើសវិធីទូទាត់',
    creditCard: 'កាតឥណទាន',
    promptPay: 'Promptpay',
    coupon: 'គូប៉ុង',
    quickpay: 'Krungsri Quick Pay',
    alipay: 'Alipay',
    linepay: 'Rabbit LINE Pay',
    thaidotcom: 'Thai Dot Com Payment',
    mounth: 'ខែ',
    dayMY: 'កាលបរិច្ឆេទ',
    item: 'ទំនិញ',
    byStockIn: 'ស្តុកចូល',
    stockOutOther: 'ផ្សេងៗ',
    drawerSales: 'ការលក់',
    sumIncomeExpenses: 'សង្ខេបចំណូល-ចំណាយ',
    incomeOther: 'ចំណូលផ្សេងៗ',
    loss: 'ការខាត',
    grossProfit: 'ប្រាក់ចំណេញដុល',
    newUser: 'អ្នកប្រើថ្មី',
    userType: 'ប្រភេទអ្នកប្រើ',
    password: 'ពាក្យសម្ងាត់',
    confirmPassword: 'បញ្ជាក់ពាក្យសម្ងាត់',
    ParticipatingProducts: 'ជ្រើសរើសផលិតផល',
    descriptionSilomOrder: 'ជ្រើសរើសផលិតផលសម្រាប់ order.silompos.com',
    cashierManagement: 'គ្រប់គ្រងបេឡាករ',
    cashierManageButton: 'គ្រប់គ្រង',
    cashierUsernamePassword: 'ឈ្មោះអ្នកប្រើ/ពាក្យសម្ងាត់',
    cashierCRUDDescription: 'សម្រាប់ចូល order.silompos.com',
    password: 'ពាក្យសម្ងាត់',
    placeholderPassword: 'យ៉ាងតិច 6 តួអក្សរ',
    resetPassword: 'កំណត់ពាក្យសម្ងាត់ឡើងវិញ',
    oldPassword: 'ពាក្យសម្ងាត់ចាស់',
    oldPasswordPlaceholder: 'ពាក្យសម្ងាត់ចាស់',
    newPassword: 'ពាក្យសម្ងាត់ថ្មី',
    purchaseDetail: 'ព័ត៌មានលម្អិតការទិញ',
    uploadImage: 'ផ្ទុករូបភាព',
    keyword: 'ពាក្យគន្លឹះ',
    firstname: 'នាមខ្លួន',
    lastname: 'នាមត្រកូល',
    province: 'ខេត្ត/ក្រុង',
    district: 'ស្រុក/ខណ្ឌ',
    subdistrict: 'ឃុំ/សង្កាត់',
    addressNumber: 'អាសយដ្ឋាន',
    setAsDefaultAddress: 'កំណត់ជាអាសយដ្ឋានលំនាំដើម',
    setAsTaxAddress: 'កំណត់ជាអាសយដ្ឋានពន្ធ',
    setAsShippingAddress: 'កំណត់ជាអាសយដ្ឋានដឹកជញ្ជូន',
    contact: 'ទំនាក់ទំនង',
    setAsDefault: 'កំណត់ជាលំនាំដើម',
    addressLists: 'បញ្ជីអាសយដ្ឋាន',
    default: 'លំនាំដើម',
    taxAddress: 'វិក្កយបត្រពន្ធ',
    shippingAddress: 'ដឹកជញ្ជូន',
    addAddress: 'បន្ថែម',
    createdAt: 'បង្កើត',
    updatedAt: 'ធ្វើបច្ចុប្បន្នភាព',
    by: 'ដោយ',
    readyForSale: 'រួចរាល់សម្រាប់លក់',
    sold: 'បានលក់',
    delete: 'លុប',
    items: 'ទំនិញ',
    itemDiscount: 'បញ្ចុះតម្លៃទំនិញ',
    failedToSave: 'រក្សាទុកបរាជ័យ!',
    dateOfBirth: 'ថ្ងៃកំណើត',
    menu: 'ម៉ឺនុយ',
    dashboardMenu: 'ផ្ទាំងគ្រប់គ្រង',
    transactionMenu: 'ប្រតិបត្តិការ',
    currentBillMenu: 'វិក្កយបត្របច្ចុប្បន្ន',
    reportMenu: 'របាយការណ៍',
    orderDeviceMenu: 'ឧបករណ៍បញ្ជាទិញ',
    memberMenu: 'សមាជិក',
    inventoryMenu: 'ស្តុក',
    productMenu: 'ផលិតផល',
    selfOrderMenu: 'ប៉ុស្ដិ៍លក់',
    settingMenu: 'ការកំណត់',
    salesReportByDate: 'ការលក់តាមកាលបរិច្ឆេទ',
    salesReportByBill: 'ការលក់តាមវិក្កយបត្រ',
    salesQuantitySummaryByProductReport: 'ការលក់តាមផលិតផល',
    quantitySummaryByPLUReport: 'ការលក់តាមផលិតផល (PLU)',
    nonSellingProduct: 'ផលិតផលមិនបានលក់',
    salesSummaryByCashierReport: 'ការលក់តាមបេឡាករ',
    salesSummaryByCategoryReport: 'ការលក់តាមប្រភេទ',
    paymentReport: 'ការទូទាត់',
    salesTaxReport: 'ពន្ធលើការលក់',
    drawerReport: 'ថត',
    voidBillReport: 'វិក្កយបត្រលុបចោល',
    timesheetReport: 'តារាងពេលវេលា',
    stockInByListReport: 'ស្តុកចូលតាមផលិតផល',
    stockOutByListReport: 'ស្តុកចេញតាមផលិតផល',
    nonAdjustStockProductReport: 'ផលិតផលមិនបានកែតម្រូវស្តុក',
    exportProductReport: 'នាំចេញផលិតផល',
    salesSummaryByOrderReport: 'តាមឧបករណ៍បញ្ជាទិញ',
    salesSummaryProductByOrderReport: 'តាមផលិតផល',
    voidBillByOrderReport: 'វិក្កយបត្រលុបចោល',
    inventoryReport: 'របាយការណ៍ស្តុក',
    inventoryReportByPLU: 'របាយការណ៍ស្តុកតាម PLU',
    inventoryReportBySerial: 'របាយការណ៍ស្តុកតាម Serial No.',
    stockMovement: 'ចលនាស្តុក',
    stockInDocument: 'ឯកសារស្តុកចូល',
    stockOutDocument: 'ឯកសារស្តុកចេញ',
    adjustStockDocument: 'ឯកសារកែតម្រូវស្តុក',
    selfOrder: 'បញ្ជាទិញដោយខ្លួនឯង',
    cashier: 'បេឡាករ',
    permission: 'សិទ្ធិ',
    menuSetting: 'កំណត់ម៉ឺនុយ',
    management: {
        txtManagement: 'គ្រប់គ្រង',
        user: 'គណនី',
        shopBranch: 'ហាង និងសាខា',
        productManagement: 'ផលិតផល',
        unitManagement: 'ឯកតា',
        categorytManagement: 'ប្រភេទ',
        inventory: 'ស្តុក',
        stockIn: 'ស្តុកចូល',
        stockOut: 'ស្តុកចេញ',
        adjustStock: 'កែតម្រូវស្តុក',
        checkStock: 'ពិនិត្យស្តុក',
        stockMovement: 'ចលនាស្តុក',
        transferStock: 'ផ្ទេរស្តុក',
        reportByPLU: 'របាយការណ៍ស្តុកតាម PLU',
        reportBySKU: 'របាយការណ៍ស្តុក',
        txtreportBySKU: 'របាយការណ៍ស្តុក',
        txtreportByPLU: 'របាយការណ៍ស្តុកតាម PLU',
        stockInDoc: 'ឯកសារស្តុកចូល',
        stockOutDoc: 'ឯកសារស្តុកចេញ',
        adjustStockDoc: 'ឯកសារកែតម្រូវស្តុក',
        transferStockDoc: 'ឯកសារផ្ទេរស្តុក',
        transferStockInDoc: 'ឯកសារផ្ទេរស្តុកចូល',
        transferStockOutDoc: 'ឯកសារផ្ទេរស្តុកចេញ',
    },
    report: {
        dashboard: 'ផ្ទាំងគ្រប់គ្រង',
        transaction: 'ប្រតិបត្តិការ',
        currentbill: 'វិក្កយបត្របច្ចុប្បន្ន',
        daily: 'តាមកាលបរិច្ឆេទ',
        txtdaily: 'របាយការណ៍លក់តាមកាលបរិច្ឆេទ',
        dailyDes: 'របាយការណ៍លក់តាមកាលបរិច្ឆេទលម្អិត',
        sellbyProduct: 'តាមវិក្កយបត្រលម្អិត',
        txtsellbyProduct: 'របាយការណ៍លក់តាមវិក្កយបត្រលម្អិត',
        sku: 'តាមផលិតផល',
        txtsku: 'របាយការណ៍លក់តាមផលិតផល',
        plu: 'តាមផលិតផល (PLU)',
        textPlu: 'របាយការណ៍លក់តាមផលិតផល (PLU)',
        paymentreport: 'របាយការណ៍ការទូទាត់',
        txtpaymentreport: 'របាយការណ៍ការទូទាត់',
        timesheet: 'តារាងពេលវេលា',
        txtTimesheet: 'របាយការណ៍តារាងពេលវេលា',
        unsell: 'ផលិតផលមិនបានលក់',
        txtUnsell: 'ផលិតផលមិនបានលក់',
        byCategory: 'តាមប្រភេទ',
        txtbyCategory: 'របាយការណ៍លក់តាមប្រភេទ',
        byCashier: 'តាមបេឡាករ',
        txtbyCashier: 'របាយការណ៍លក់តាមបេឡាករ',
        salesTax: 'របាយការណ៍ពន្ធលើការលក់',
        txtSalesTax: 'របាយការណ៍ពន្ធលើការលក់',
        voidbill: 'វិក្កយបត្រលុបចោល',
        txtvoidbill: 'របាយការណ៍វិក្កយបត្រលុបចោល',
        closedSale: 'បិទការលក់',
        txtCloseSale: 'របាយការណ៍ថត',
        salesByOrder: 'សង្ខេបការលក់',
        productByOrder: 'តាមផលិតផល',
        unsalesByOrder: 'វិក្កយបត្រលុបចោល',
        txtDeliveryRoport: 'របាយការណ៍ការទូទាត់តាមការដឹកជញ្ជូន',
        txtCustomReport: 'របាយការណ៍ការទូទាត់ផ្ទាល់ខ្លួន',
        txtSalesByOrder: 'ការលក់ផលិតផលតាមឧបករណ៍បញ្ជាទិញ',
        txtDailyOrder: 'របាយការណ៍លក់តាមឧបករណ៍បញ្ជាទិញ',
        txtViodOrder: 'វិក្កយបត្រលុបចោលតាមឧបករណ៍បញ្ជាទិញ',
        nonadjust: 'ផលិតផលមិនបានកែតម្រូវស្តុក',
        txtnonadjust: 'របាយការណ៍ផលិតផលមិនបានកែតម្រូវស្តុក',
        stockInReport: 'របាយការណ៍ស្តុកចូលតាមផលិតផល',
        stockOutReport: 'របាយការណ៍ស្តុកចេញតាមផលិតផល',
        stockIn: 'ស្តុកចូលតាមផលិតផល',
        stockOut: 'ស្តុកចេញតាមផលិតផល',
        exportProduct: 'នាំចេញផលិតផល',
        txtExportProduct: 'របាយការណ៍នាំចេញផលិតផល',
        cashDrawer: 'ថត',
        txtCashDrawerr: 'របាយការណ៍គ្រប់គ្រងសាច់ប្រាក់',
        cashRevenue: 'ចំណូលសាច់ប្រាក់',
    },
    drawer: {
        cashDrawer: 'ថត',
        txtCashDrawerr: 'របាយការណ៍គ្រប់គ្រងសាច់ប្រាក់',
        cashRevenue: 'សង្ខេបចំណូល-ចំណាយ',
        txtcashRevenue: 'របាយការណ៍សង្ខេបចំណូល-ចំណាយ',
    },
    member: {
        txtmember: 'សមាជិក',
        register: 'ចុះឈ្មោះហាង (LINE OA)',
        loyaltyPoint: 'ពិន្ទុស្មោះស្ម័គ្រ',
        storeCredit: 'ឥណទានហាង',
        deal: 'កិច្ចព្រមព្រៀង',
        giftVoucher: 'វិក័យប័ត្រអំណោយ',
        referral: 'អញ្ជើញ',
        crm: 'Silom CRM',
    },
    unableStockDescription: 'មិនអាចកែសម្រួលផលិតផលបានទេ ដោយសារស្តុកត្រូវបានធ្វើបច្ចុប្បន្នភាពបន្ទាប់ពីបង្កើតឯកសារ។',
    noItem: 'គ្មានទំនិញ',
    enterProductName: 'បញ្ចូលឈ្មោះផលិតផល',
    ByCategory: 'តាមប្រភេទ',
    ByCategoryDetail: 'ព័ត៌មានលម្អិតតាមប្រភេទ',
    maximum: 'អតិបរមា',
    selectZone: 'ជ្រើសរើសតំបន់',
    minimum: 'អប្បបរមា',
    unlimited: 'គ្មានកំណត់',
    startTime: 'ម៉ោងចាប់ផ្ដើម',
    endTime: 'ម៉ោងបញ្ចប់',

    "errorMessages": {
        "qrExpired": "QR Code ផុតកំណត់",
        "qrNotFound": "រកមិនឃើញ QR Code",
        "paymentSuccess": "ទូទាត់ជោគជ័យ",
        "invalidQrType": "ប្រភេទ QR Code មិនត្រឹមត្រូវ",
        "tableMoved": "តុត្រូវបានផ្លាស់ប្ដូរ",
        "receiptVoided": "វិក្កយបត្រត្រូវបានលុបចោល"
    },
    "errorDescriptions": {
        "qrExpired": "QR Code ដែលអ្នកប្រើបានផុតកំណត់។<br>សូមទាក់ទងបុគ្គលិកសម្រាប់ជំនួយ។",
        "qrNotFound": "រកមិនឃើញព័ត៌មាន QR Code សម្រាប់បញ្ជាទិញអាហារ។<br>សូមទាក់ទងបុគ្គលិក។",
        "paymentSuccess": "សូមអរគុណសម្រាប់ការប្រើសេវាកម្ម!",
        "invalidQrType": "សូមទាក់ទងបុគ្គលិកដើម្បីទទួល QR Code ថាមវន្ត។",
        "tableMoved": "សូមទាក់ទងបុគ្គលិកដើម្បីទទួល QR Code ថ្មី។",
        "receiptVoided": "សូមអរគុណសម្រាប់ការប្រើសេវាកម្ម។<br>សូមទាក់ទងបុគ្គលិកប្រសិនបើអ្នកត្រូវការជំនួយ។"
    },
    waitForServe: 'រង់ចាំការបម្រើ',
    DineInPaymentDetails: 'ការទូទាត់',
    silomPayProDesp: 'ការទូទាត់សុវត្ថិភាពដោយ Silom Pay Easy',
    billDetail: 'ព័ត៌មានលម្អិតវិក្កយបត្រ',
    minute: 'នាទី',
    paymentTImeExpired: 'ផុតកំណត់ពេល',
    openApp: 'បើកកម្មវិធី',
    callPayStaffSuccess: 'បានហៅបុគ្គលិក<br>សូមរង់ចាំជំនួយសម្រាប់បញ្ចប់ការទូទាត់',
    account: 'គណនី',
    refNumber: 'លេខយោង',
    QRCodeBBL: 'QR Code កាតឥណទាន',
    trackOrderStatus: 'តាមដានស្ថានភាពការបញ្ជាទិញ',
    all: 'ទាំងអស់',
    noOrderThisStatus: 'គ្មានការបញ្ជាទិញក្នុងស្ថានភាពនេះ',
    orderCompleteThanks: 'សូមអរគុណសម្រាប់ការប្រើសេវាកម្ម!',
    OnPreparingYourOrder: 'កំពុងរៀបចំការបញ្ជាទិញរបស់អ្នក...',
    goToTracking: 'ទៅទំព័រតាមដាន',
    "dine-in": 'ញ៉ាំក្នុងហាង',
    typeOfOrder: 'ប្រភេទការបញ្ជាទិញ',
    queue: 'លេខរង់ចាំ',
    cooking: 'កំពុងចម្អិន',
    orderedAt: 'បញ្ជាទិញនៅម៉ោង',
    orderTimeStatus: 'ម៉ោងបញ្ជាទិញ',
    acceptTimeStatus: 'ម៉ោងទទួល',
    estTimeStatus: 'ម៉ោងប៉ាន់ស្មាន',
    newOrderDelivery: 'ការបញ្ជាទិញថ្មី',
    acceptOrderDelivery: 'ទទួលការបញ្ជាទិញ',
    readyToServeDelivery: 'រួចរាល់សម្រាប់បម្រើ',
    orderCompleted: 'ការបញ្ជាទិញបានបញ្ចប់',
    orderCanceled: 'ការបញ្ជាទិញត្រូវបានបោះបង់',
    readyToShip: 'រួចរាល់សម្រាប់ដឹកជញ្ជូន',
    scanForPayment: 'ស្កេនដើម្បីទូទាត់',
    orderType: 'ប្រភេទការបញ្ជាទិញ',
    welcomeBack: "សូមស្វាគមន៍ 👋",
    welcomeBackDespt: "ចូលដើម្បីបន្តបញ្ជាទិញអាហារ",
    orLoginWith: "ឬចូលដោយ",
    dontHaveAccount: 'មិនទាន់មានគណនីទេ?',
    register: 'ចុះឈ្មោះ',
    fullName: "ឈ្មោះពេញ",
    fullNameDespt: 'ឈ្មោះពេញរបស់អ្នក',
    emailDespt: 'អ៊ីមែលរបស់អ្នក',
    createPassword: 'បង្កើតពាក្យសម្ងាត់',
    alreadyHaveAccount: 'មានគណនីរួចហើយ',
    verifyEmail: 'ផ្ទៀងផ្ទាត់អ៊ីមែល',
    enterOTPSentTo: 'បញ្ចូល OTP ដែលបានផ្ញើទៅ',
    enterSixOTP: 'បញ្ចូល OTP 6 ខ្ទង់',
    verifyOTP: 'ផ្ទៀងផ្ទាត់ OTP',
    weWillSentOTPEmail: 'យើងនឹងផ្ញើ OTP ទៅអ៊ីមែលរបស់អ្នក',
    enterYourEmail: 'បញ្ចូលអ៊ីមែលរបស់អ្នក',
    confirmNewPassword: 'បញ្ជាក់ពាក្យសម្ងាត់ថ្មី',
    sendOTP: 'ផ្ញើ OTP',
    addPhoneNumber: 'បន្ថែមលេខទូរសព្ទ',
    addPhoneForRegister: 'បន្ថែមលេខទូរសព្ទសម្រាប់ចុះឈ្មោះ',
    enterPhone: 'បញ្ចូលលេខទូរសព្ទ',
    phoneUsed: 'លេខទូរសព្ទត្រូវបានប្រើរួចហើយ',
    emailUsed: 'អ៊ីមែលត្រូវបានប្រើរួចហើយ',
    enterPassword: 'បញ្ចូលពាក្យសម្ងាត់របស់អ្នក',
    registerEmail: 'អ៊ីមែលដែលបានចុះឈ្មោះ',
    otpInvalid6: "សូមបញ្ចូល OTP 6 ខ្ទង់ត្រឹមត្រូវ។",
    emailVerified: "ផ្ទៀងផ្ទាត់អ៊ីមែលជោគជ័យ!",
    emailOrPasswordInvalid: 'អ៊ីមែល ឬពាក្យសម្ងាត់មិនត្រឹមត្រូវ',
    pleaseEnterEmail: 'សូមបញ្ចូលអ៊ីមែលរបស់អ្នក',
    otpSentToEmail: "បានផ្ញើ OTP ទៅអ៊ីមែលរបស់អ្នក",
    passwordNotMatch: "ពាក្យសម្ងាត់មិនត្រូវគ្នា",
    resetPasswordCompleted: 'កំណត់ពាក្យសម្ងាត់ឡើងវិញជោគជ័យ!',
    failResetPassword: 'កំណត់ពាក្យសម្ងាត់ឡើងវិញបរាជ័យ',
    completePhoneFail: 'ចុះឈ្មោះលេខទូរសព្ទបរាជ័យ',
    plaseEnterValidEmail: 'សូមបញ្ចូលអាសយដ្ឋានអ៊ីមែលត្រឹមត្រូវ',
    invalidPhoneNumber: 'លេខទូរសព្ទត្រូវចាប់ផ្ដើមដោយ 06, 08, ឬ 09 និងមាន 10 ខ្ទង់',
    example: 'ឧទាហរណ៍',
    passwordSet: "ច្រើនជាង 6 តួអក្សរ និងត្រូវមានលេខ",
    SelectTableToAdd: 'តុ',
    availableTable: 'មាន',
    unAvailableTable: 'មិនមាន',
    SelectTableToAddDesp: 'ជ្រើសរើសតុសម្រាប់ញ៉ាំក្នុងហាង<br>ចំណាំ: ប្រសិនបើអ្នកចង់ផ្លាស់ប្ដូរតុ សូមទាក់ទងបុគ្គលិក',
    updatedStaus: 'ស្ថានភាពត្រូវបានធ្វើបច្ចុប្បន្នភាព',
    otpExpired: 'OTP ផុតកំណត់',
    and: "និង",
    emailOTP: "អ៊ីមែល OTP",
    emailOTPDesp: "បញ្ចូល OTP ដែលបានទទួលតាមអ៊ីមែល",
    phoneOTP: "ទូរសព្ទ OTP",
    phoneOTPDesp: "បញ្ចូល OTP ដែលបានទទួលតាម SMS",
    checkSpamBox: '* ប្រសិនបើអ្នកមិនទទួលបានអ៊ីមែល សូមពិនិត្យថត Spam ឬ Junk របស់អ្នក។ ពេលខ្លះអាចចំណាយពេលពីរបីនាទីដើម្បីមកដល់។',
    DineInPaymentPending: 'រង់ចាំការទូទាត់',
    visitProceedPayment: 'ទៅការទូទាត់',
    proceedPayment: "បន្តការទូទាត់",
    proceedPaymentDesp: "វិក្កយបត្រនេះកំពុងត្រូវបានដំណើរការសម្រាប់ការទូទាត់។<br>ប្រសិនបើអ្នកចង់បញ្ជាទិញទំនិញបន្ថែម<br>សូមបោះបង់ការទូទាត់ដែលកំពុងដំណើរការមុន",
    queueIndex: 'លេខរង់ចាំ',
    otpSentToPhone: 'បានផ្ញើ OTP តាម SMS។',
    failToSendOTP: 'ផ្ញើ OTP បរាជ័យ',
    somethingWentWrong: 'មានអ្វីមួយខុសប្រក្រតី',
    tableHasNoOrder: 'តុមិនមានការបញ្ជាទិញ',
    kbankProceedPaymentDesp: 'វិក្កយបត្រនេះកំពុងត្រូវបានដំណើរការសម្រាប់ការទូទាត់។<br>ប្រសិនបើអ្នកចង់បន្ថែមទំនិញ ឬផ្លាស់ប្ដូរវិធីទូទាត់<br>សូមបោះបង់ការទូទាត់ដែលកំពុងដំណើរការមុន'
,
  openHours: 'បើក',
}

export default messages
